import { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { Button, Drawer, Text, Input, Icon } from "@ui-component-library";
import { TwTabs as Tabs } from "@ui-component-library";
import { DynamicModal } from "@components/DynamicModal";

import WidgetWrapper from "../comps/WidgetWrapper";
import Sawtimber from "./widgets/Sawtimber";
import Pulpwood from "./widgets/Pulpwood";

import { useVisaValdaStore } from "../store/VisaValdaStore";
import { useWoodprices } from "./context/Woodprices";
import Podcasts from "./widgets/Podcasts";
import Posts from "./widgets/Posts";
import HistoricPrices from "./widgets/HistoricPrices";

import FilterIcon from "@assets/icons/filter.svg";
import CrossIcon from "@assets/icons/cross.svg";
import CaretIcon from "@assets/icons/caret-right.svg";
import PlusIcon from "@assets/icons/plus.svg";
import { useDemoMinskogStore } from "../store/DemoMinskogStore";
import { DEMO_PROMPTS } from "../constants/demoPrompts";
import { useNavigationStore } from "../store/NavigationStore";


const PropselectorContainer = styled.div`
  width: 90vw;
  max-width: 450px;
  top: 10px;
`;

export default function Woodprices() {
  const { visaValda, setVisaValda } = useVisaValdaStore();
  const { view, setView } = useNavigationStore();
  const {isDemo, DemoBlockFunctionWrapper} = useDemoMinskogStore()
  const [selectedPost, setSelectedPost] = useState(null);
  const [filterShow, setFilterShow] = useState(false);
  const [showMuniModal, setShowMuniModal] = useState(false);
  const [muniSearch, setMuniSearch] = useState('');
  const scrollContainerRef = useRef(null);
  const { sawtimberOptions, setsawtimberOptions, pulpwoodOptions, setPulpwoodOptions, historicOptions, setHistoricOptions, munis, muni, setMuni } = useWoodprices();

  useEffect(() => {
    if (visaValda) {
      const muniStorage = localStorage.getItem('woodprices_muni')
      if (muni != muniStorage) {
        setMuni(muniStorage)
      }

      setVisaValda(false)
    }
  }, [visaValda]);

  useEffect(() => {
    if(isDemo){
      setMuni("Umeå");
    }
  }, [isDemo])



  useEffect(() => {
    if (selectedPost && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ behavior: 'smooth', top: 0 })
    }
  }, [selectedPost]);

  useEffect(() => {
    if (view?.comp === 'virkespriser' && view?.postId == null && selectedPost) {
      setSelectedPost(null);
    }
  }, [view?.comp, view?.postId]);

  const openPost = (post) => {
    setSelectedPost(post);
    const newView = { comp: 'virkespriser', postId: post?.id };
    history.pushState(newView, '', '');
    setView(newView);
  };

  const divider = () => {
    return <div className='bg-[#E6E6E6]' style={{ width: '2px', height: '60%' }}></div>
  }

  const selectMuni = () => {
    return <div className='flex flex-col flex-1 justify-center items-center p-8'>
      <div className='text-center max-w-[280px]'>
        <div className='flex justify-center mb-3'>
          <div className='border border-solid border-[#E5E5E5] rounded p-2'>
            <PlusIcon width='20px' />
          </div>
        </div>
        <Text variant='text-lg/leading-normal/semibold'>Ingen kommun vald</Text>
        <Text className='text-[#737373] mb-4' variant='text-sm/leading-normal/normal'>För att se priserna, välj en kommun.</Text>
        <Button size='small' className='w-full' onClick={() => setShowMuniModal(true)}>Välj kommun</Button>
      </div>
    </div>
  }

  const sawtimberFilterContent = (isMobile) => {
    return <>
      {isMobile ? <Text variant="text-sm/leading-normal/normal">Trädslag</Text> : divider()}
      <div className="bg-cloud-200 rounded-lg-alt w-fit">
        <Tabs
          value={sawtimberOptions.tree}
          tabs={[{ label: "Tall", value: "tall" }, { label: "Gran", value: "gran" }]}
          onChange={(value) => setsawtimberOptions(prev => ({ ...prev, tree: value }))} />
      </div>

      {isMobile ? <Text className='mt-4' variant="text-sm/leading-normal/normal">Sortiment</Text> : divider()}
      <div className="bg-cloud-200 rounded-lg-alt w-fit">
        <Tabs
          value={sawtimberOptions.size}
          tabs={[{ label: "Klentimmer", value: "thin" }, { label: "Normaltimmer", value: "normal" }, { label: "Grovtimmer", value: "thick" }]}
          onChange={(value) => setsawtimberOptions(prev => ({ ...prev, size: value }))} />
      </div>

      {isMobile ? <Text className='mt-4' variant="text-sm/leading-normal/normal">Kvalitet</Text> : divider()}
      <div className="bg-cloud-200 rounded-lg-alt w-fit">
        <Tabs
          value={sawtimberOptions.quality}
          tabs={sawtimberOptions.tree == 'tall' ? [{ label: "1", value: "one" }, { label: "2", value: "two" }, { label: "3", value: "three" }, { label: "4", value: "four" }] : [{ label: "1", value: "one" }, { label: "2", value: "two" }]}
          onChange={(value) => setsawtimberOptions(prev => ({ ...prev, quality: value }))} />
      </div>
    </>
  }

  const pulpwoodFilterContent = (isMobile) => {
    return <>
      {isMobile ? <Text variant="text-sm/leading-normal/normal">Trädslag</Text> : divider()}
      <div className="bg-cloud-200 rounded-lg-alt w-fit">
        <Tabs
          value={pulpwoodOptions.tree}
          tabs={[{ label: "Tall", value: "tall" }, { label: "Gran", value: "gran" }, { label: "Löv", value: "lov" }]}
          onChange={(value) => setPulpwoodOptions(prev => ({ ...prev, tree: value }))} />
      </div>

      {isMobile ? <Text className='mt-4' variant="text-sm/leading-normal/normal">Kvalitet</Text> : divider()}
      <div className="bg-cloud-200 rounded-lg-alt w-fit">
        <Tabs
          value={pulpwoodOptions.quality}
          tabs={[{ label: "Prima", value: "one" }, { label: "Sekunda", value: "two" }]}
          onChange={(value) => setPulpwoodOptions(prev => ({ ...prev, quality: value }))} />
      </div>
    </>
  }


  return <div className="relative bg-cloud-50" style={{ minHeight: "100dvh" }}>
    {!isDemo && <PropselectorContainer className="sticky top-0 z-[1040] mx-auto">
      <>
        <div className='flex justify-between bg-white rounded border cursor-pointer border-solid border-[#E6E6E6] max-w-[450px] p-2 mt-2' style={{ boxShadow: '1px 1px 20px rgba(0, 0, 0, .2)' }} onClick={() => setShowMuniModal(true)}>
          <Text className='text-[#737373]' variant='text-sm/leading-normal/normal'>{muni ? muni : 'Välj kommun'}</Text>
          <CaretIcon fill='#737373' width='20px' className='rotate-90' />
        </div>
      </>
    </PropselectorContainer>}

    <>
      <div className="pt-[40px]">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 auto-rows-auto md:auto-rows-[480px] gap-4 max-w-[1240px] px-4 md:px-8 pt-4 mx-auto mb-8">
          <WidgetWrapper
            title="Historiska virkespriser (kr/m³fub)"
            className="flex flex-col col-span-1 md:col-span-2 xl:col-span-3"
            extraContent={(<>
              {divider()}
              <div className="bg-cloud-200 rounded-lg-alt items-center justify-center">
                <Tabs
                  value={historicOptions.tree}
                  tabs={[{ label: "Tall", value: "tall" }, { label: "Gran", value: "gran" }]}
                  onChange={(value) => setHistoricOptions(prev => ({ ...prev, tree: value }))} />
              </div>
            </>)}
            infoContent={
              <div className="flex flex-col">
                <Text variant="text-sm/leading-normal/normal">Här ser du historiska virkespriser för både tall och gran, baserat på faktiska affärer i din region. Genom att välja den tidsperiod du vill analysera får du en tydlig överblick och kontroll över marknadens svängningar. Vi ger dig underlaget - så att du kan ta rätt beslut för din skog och din ekonomi.</Text>
              </div>
            }
          >
            <HistoricPrices selectMuni={() => selectMuni()} />
          </WidgetWrapper>

          <WidgetWrapper
            title="Sågtimmer  (kr/m³fub)"
            className="flex flex-col col-span-1 md:col-span-2 xl:col-span-3"
            extraContent={(<>
              <div className='md:hidden ml-auto'>
                {divider()}
                <Button size='small' variant='outline' onClick={() => setFilterShow('sawtimber')}><FilterIcon width='20px' /> Alternativ</Button>
              </div>
              <div className='hidden md:flex h-full items-center gap-2'>
                {sawtimberFilterContent(false)}
              </div>
            </>)}
            infoContent={
              <div className="flex flex-col">
                <Text className='mb-3' variant="text-sm/leading-normal/normal">Här kan du enkelt jämföra aktuella listpriser för tall och gran per köpande bolag. Du väljer själv om du vill se priser för klentimmer, normaltimmer eller grovtimmer för att få en rättvis bild av marknaden.</Text>

                <Text variant="text-sm/leading-normal/normal">Vi visar priser för samtliga kvaliteter, där kvalitet 1 är det vanligaste för gran och kvalitet 2 för tall. Genom att synliggöra dessa skillnader ger vi dig kontroll över din skogs värden och hjälper dig att fatta smarta beslut inför din nästa affär.</Text>

                <Text variant="text-sm/leading-normal/normal">I de fall ett företag har priser för både leveransvirke och avverkningsuppdrag visar vi det högsta priset.</Text>
              </div>
            }
          >
            <Sawtimber selectMuni={() => selectMuni()} />
          </WidgetWrapper>

          <WidgetWrapper
            title="Massaved (kr/m³fub)"
            className="flex flex-col col-span-1 md:col-span-2 xl:col-span-3"
            extraContent={(<>
              <div className='md:hidden ml-auto'>
                {divider()}
                <Button size='small' variant='outline' onClick={() => setFilterShow('pulpwood')}><FilterIcon width='20px' /> Alternativ</Button>
              </div>
              <div className='hidden md:flex h-full items-center gap-2'>
                {pulpwoodFilterContent(false)}
              </div>
            </>)}
            infoContent={
              <div className="flex flex-col">
                <Text variant="text-sm/leading-normal/normal">Här visar vi aktuella listpriser för massaved. För att ge dig en så komplett bild som möjligt kan du jämföra priser för både gran, tall och lövträ. Vi visar priser för samtliga kvaliteter, där Prima är den absolut vanligaste för massaved. Genom att ge dig tillgång till uppdaterade priser skapar vi transparens och ger dig kontroll över din skogs värden.</Text>
              </div>
            }
          >
            <Pulpwood selectMuni={() => selectMuni()} />
          </WidgetWrapper>

          <WidgetWrapper
            title="Treebula Studio"
            className="flex flex-col col-span-1 overflow-hidden"
            headerClass="justify-between"
            extraContent={<Button variant="secondary" size="small" onClick={() => DemoBlockFunctionWrapper(() => window.open('/kunskapscentrum/treebula-studio/', '_blank'), DEMO_PROMPTS.ARTICLES)}>Se alla</Button>}
          >
            <Podcasts />
          </WidgetWrapper>

          <WidgetWrapper
            title="Händelser"
            className="flex flex-col col-span-1 overflow-hidden"
            headerClass="justify-between"
            extraContent={<Button variant="secondary" size="small" onClick={() => DemoBlockFunctionWrapper(() => window.open('/kunskapscentrum/', '_blank'), DEMO_PROMPTS.ARTICLES)}>Se alla</Button>}
          >
            <Posts onPostSelect={(post) => DemoBlockFunctionWrapper(() => {
              setView({ comp: 'marknadsinformation', postId: post.id });
              if (history.state?.comp !== 'marknadsinformation' || history.state?.postId !== post.id) {
                history.pushState({ comp: 'marknadsinformation', postId: post.id }, '', '');
              }
            }, DEMO_PROMPTS.READ_ARTICLE)} />
          </WidgetWrapper>
        </div>
      </div>

      <Drawer isOpen={filterShow} onClose={() => setFilterShow(false)}>
        <Drawer.Header className="pb-2-5 justify-between items-center">
          <div className="flex w-full items-center justify-between">
            <Text variant="text-sm/leading-normal/medium">Filter</Text>
            <Button variant="tertiary" size="icon" onClick={() => setFilterShow(false)} aria-label="Stäng">
              <CrossIcon width='20px' />
            </Button>
          </div>
        </Drawer.Header>
        <Drawer.Content>
          {filterShow == 'sawtimber' ? sawtimberFilterContent(true) : pulpwoodFilterContent(true)}
        </Drawer.Content>
        <Drawer.Footer>
          <Button className='w-full' onClick={() => setFilterShow(false)}>Spara & stäng</Button>
        </Drawer.Footer>
      </Drawer>

      <DynamicModal isOpen={showMuniModal} onClose={() => setShowMuniModal(false)} bp={{ sm: "drawer", lg: "sheet" }} >
        <DynamicModal.Header>
          <div className="w-full text-center">
            <Text variant="text-sm/leading-normal/medium">Välj kommun</Text>
          </div>
        </DynamicModal.Header>

        <DynamicModal.Content>
          <div className='flex flex-col overflow-hidden h-full'>
            <Input debounceDelay={0} variant="fluid" label="Sök kommun" value={muniSearch} onChange={(val) => setMuniSearch(val)} />

            <div className='flex-1 overflow-y-auto mt-2'>
              {munis?.map((m, index) => {
                if (muniSearch && !m.label.toLowerCase().includes(muniSearch.toLowerCase())) {
                  return null
                }
                const classes = m.label == muni ? 'bg-cloud-300 rounded-lg-alt' : '';
                return <div key={index} className={`cursor-pointer my-2 p-2 ${classes}`} onClick={() => setMuni(m.label)}>
                  <Text variant='text-sm/leading-normal/medium' className='text-start'>{m.label}</Text>
                </div>
              })}
            </div>
          </div>
        </DynamicModal.Content>

        <DynamicModal.Footer>
          <Button variant="primary" fullWidth onClick={() => setShowMuniModal(false)}>Stäng</Button>
        </DynamicModal.Footer>
      </DynamicModal>
    </>
  </div>;
}
